import {isAnyOf} from '@reduxjs/toolkit'

import {APIStatus, ClosingMethod, OrderPhase, OrderEntry} from '@web/core/constants'
import makeSlice from '@web/slices/common/sliceMaker'

import {initOrderSheetByAPI, initResult} from '../../actions/familyPay'
import {
    initFamilyPayUser,
    agreeFamilyPayUser,
    withdrawFamilyPayUser,
    getFamilyPayUser,
} from '../../actions/familyPayUser'

const isFetchingAction = isAnyOf(
    initOrderSheetByAPI.pending,
    initResult.pending,
    initFamilyPayUser.pending,
    agreeFamilyPayUser.pending,
    withdrawFamilyPayUser.pending,
    getFamilyPayUser.pending,
)
const isResolvedAction = isAnyOf(
    initOrderSheetByAPI.fulfilled,
    initResult.fulfilled,
    initFamilyPayUser.fulfilled,
    agreeFamilyPayUser.fulfilled,
    withdrawFamilyPayUser.fulfilled,
    getFamilyPayUser.fulfilled,
)
const isRejectedAction = isAnyOf(
    initOrderSheetByAPI.rejected,
    initFamilyPayUser.rejected,
    initResult.rejected,
    agreeFamilyPayUser.rejected,
    withdrawFamilyPayUser.rejected,
    getFamilyPayUser.rejected,
)

const slice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {
                    data: {orderNo},
                } = payload

                state.seqID = orderNo
                state.closingType = ClosingMethod.BACK
                state.entry = OrderEntry.FAMILY_PAY
                state.orderPhase = OrderPhase.CHECKOUT
            })
            .addCase(initResult.fulfilled, (state, {payload}) => {
                const {orderNo} = payload

                state.seqID = orderNo
                state.closingType = ClosingMethod.BACK
                state.entry = OrderEntry.FAMILY_PAY
                state.orderPhase = OrderPhase.RESULT
            })
            .addMatcher(isFetchingAction, (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addMatcher(isResolvedAction, (state) => {
                state.scene = APIStatus.RESOLVED
            })
            .addMatcher(isRejectedAction, (state) => {
                state.scene = APIStatus.REJECTED
            })
    },
})

export default slice.reducer
